var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUmmahfy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "rgba(255, 255, 255, 0.7)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgba(255, 255, 255, 0.7)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "rgba(255, 255, 255, 0.1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 215.28,
    r: 93.75,
    fill: "url(#linear-gradient-2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m250,500c68.91,0,131.31-27.89,176.53-72.99-25.96-42.24-95.18-72.47-176.53-72.47s-150.57,30.22-176.53,72.47c45.22,45.1,107.62,72.99,176.53,72.99Z",
    fill: "url(#linear-gradient-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUmmahfy);
export default __webpack_public_path__ + "static/media/IconUmmahfy.08189588d1e2a319c03c992cf37b4fbd.svg";
export { ForwardRef as ReactComponent };